// Actions
export const MODAL_LOAD_ACTIONS_TYPES = {
    loading: () => 'MODAL_LOADING', 
    hideLoad: () => 'HIDE_LOAD',
    showSuccess: () => 'SHOW_SUCCESS',
    showWarning: () => 'SHOW_WARNING',
    showError: () => 'SHOW_ERROR',
    setTitle: () => 'SET_TITLE',
};
  